export const useDropdownSelection = () => {
    return '$primary_dim';
};
